import { takeEvery, put, call } from "redux-saga/effects";
import {
  UPDATE_PROFILE_ACTIVITATE,
  UPDATE_PROFILE_DEACTIVATE,
} from "./actionTypes";
import {
  updateProfileActivateSuccess,
  updateProfileActivateError,
  updateProfileDectivateSuccess,
  updateProfileDectivateError,
} from "./actions";
import { patchActivateUserAccount, patchDeactivateUserAccount } from "../../helpers/api";
import { togglePageLoader } from "../actions";
import { notifications } from "@mantine/notifications";

function* updateProfileActivate({ payload: data, callback }) {
  try {
    let notificationColor;
    yield put(togglePageLoader(true));
    const response = yield call(patchActivateUserAccount, data);
    if (response.status !== "Error") {
      yield put(updateProfileActivateSuccess(response));
      notificationColor = "lime";
      callback("Activate Success");
      yield put(togglePageLoader(false));
    } else {
      notificationColor = "red";
      callback("Activate Failure");
      yield put(updateProfileActivateError(response));
      yield put(togglePageLoader(false));
      // notifications.show({ message: response.title || response.message });
    }
    if (notifications && notifications.show) {
      // notification setup
      notifications.show({
        title: "Activate User",
        message: response.title || response.message,
        color: notificationColor,
      });
    }
  } catch (error) {}
}

// deactiviate account profile
function* updateProfileDeActivate({ payload: data, callback }) {
  try {
    let notificationColor;
    yield put(togglePageLoader(true));
    const response = yield call(patchDeactivateUserAccount, data);
    if (response.status !== "Error") {
      yield put(updateProfileDectivateSuccess(response));
      notificationColor = "lime";
      callback("DeActivate Success");
      yield put(togglePageLoader(false));
    } else {
      notificationColor = "red";
      callback("DeActivate Failure");
      yield put(updateProfileDectivateError(response));
      yield put(togglePageLoader(false));
      // notifications.show({ message: response.title || response.message });
    }
    if (notifications && notifications.show) {
      // notification setup
      notifications.show({
        title: "De-Activate User",
        message: response.title || response.message,
        color: notificationColor,
      });
    }
  } catch (error) {}
}

function* updateProfileSaga() {
  yield takeEvery(UPDATE_PROFILE_ACTIVITATE, updateProfileActivate);
  yield takeEvery(UPDATE_PROFILE_DEACTIVATE, updateProfileDeActivate);
}

export default updateProfileSaga;
